{
  "pages": [
    {
      "name": "Simple Buffer Tank",
      "elements": [
        {
          "type": "panel",
          "name": "Simple Buffer Tank",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            }
          ],
          "title": "Simple Buffer tank info",
          "isRequired": true
        }
      ]
    }
  ]
}